import { Component, EventEmitter, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pcp-sw-update-notification',
    templateUrl: './sw-update-notification.component.html',
    styleUrls: ['./sw-update-notification.component.scss'],
    imports: [MatButton]
})
export class SwUpdateNotificationComponent {

    /** emits `true` if the user has accepted, `false` if he has declined. */
    @Output() confirmed = new EventEmitter<boolean>();

    accept(evt: Event) {
        evt.preventDefault();
        this.confirmed.next(true);
    }

    decline(evt: Event) {
        evt.preventDefault();
        this.confirmed.next(false);
    }

}
